export const faceSwapeEnvOptions = {
    environment: {
      environmentAtmosphere: {
        label: 'Atmosphere',
        options: {
          warmSunlight: 'Warm Sunlight',
          coolTone: 'Cool Tone',
          darkAtmosphere: 'Dark Atmosphere',
          cloudyHazy: 'Cloudy/Hazy Environment',
          lightThroughWindow: 'Light Through Window'
        }
      },
      lightStyle: {
        label: 'Lighting Style',
        options: {
          naturalSunlight: 'Natural Sunlight',
          softAmbientLight: 'Soft Ambient Light',
          harshSunlight: 'Harsh Sunlight',
          overcastSky: 'Overcast Sky',
          sunsetGlow: 'Sunset Glow',
          candlelight: 'Candlelight',
          moonlight: 'Moonlight',
          backlitSilhouette: 'Backlit Silhouette',
          spotlight: 'Spotlight',
          rimLighting: 'Rim Lighting',
          studioLighting: 'Studio Lighting',
          goldenHourLight: 'Golden Hour Light',
          blueHourLight: 'Blue Hour Light',
          neonLights: 'Neon Lights'
        }
      },
      lightDirection: {
        label: 'Lighting Direction',
        options: {
          fromTop: 'From Top',
          fromBottom: 'From Bottom',
          fromRight: 'From Right',
          fromLeft: 'From Left',
          fromFront: 'From Front',
          fromTopRight: 'From Top-Right',
          fromTopLeft: 'From Top-Left'
        }
      },
      background: {
        label: 'Background',
        options: {
          naturalLandscape: 'Natural Landscape',
          urbanBackground: 'Urban Background',
          simpleBackground: 'Simple Background',
          indoorBackground: 'Indoor Background',
          virtualBackground: 'Virtual Background'
        }
      },
      backgroundEffect: {
        label: 'Background Effect',
        options: {
          dynamicBackground: 'Dynamic Background',
          neonLightBackground: 'Neon Light Background',
          starrySkyBackground: 'Starry Sky Background',
          fogMistEffect: 'Fog/Mist Effect',
          minimalistBackground: 'Minimalist Background'
        }
      },
      backgroundBlur: {
        label: 'Background Blur',
        options: {
          slightBlur: 'Slight Blur',
          strongBlur: 'Strong Blur',
          hazeEffect: 'Haze Effect'
        }
      }
    }
  };
